import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsertImage = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.3327 8.33333H17.5003C16.3395 8.33333 15.759 8.33333 15.2703 8.38358C10.7529 8.84798 7.18164 12.4192 6.71724 16.9366C6.70002 17.1041 6.6887 17.2824 6.68126 17.4911M18.3327 8.33333C18.3337 8.59356 18.3337 8.87073 18.3337 9.16667V10.8333C18.3337 13.1669 18.3337 14.3337 17.8795 15.225C17.48 16.009 16.8426 16.6464 16.0586 17.0459C15.1673 17.5 14.0005 17.5 11.667 17.5H8.33366C7.70367 17.5 7.15871 17.5 6.68126 17.4911M18.3327 8.33333C18.3264 6.54161 18.2761 5.55331 17.8795 4.77504C17.48 3.99103 16.8426 3.35361 16.0586 2.95414C15.1673 2.5 14.0005 2.5 11.667 2.5H8.33366C6.00011 2.5 4.83333 2.5 3.94203 2.95414C3.15802 3.35361 2.5206 3.99103 2.12113 4.77504C1.66699 5.66634 1.66699 6.83311 1.66699 9.16667V10.8333C1.66699 13.1669 1.66699 14.3337 2.12113 15.225C2.5206 16.009 3.15802 16.6464 3.94203 17.0459C4.59271 17.3774 5.39019 17.4669 6.68126 17.4911M6.25033 7.91667C5.79009 7.91667 5.41699 7.54357 5.41699 7.08333C5.41699 6.6231 5.79009 6.25 6.25033 6.25C6.71056 6.25 7.08366 6.6231 7.08366 7.08333C7.08366 7.54357 6.71056 7.91667 6.25033 7.91667Z",
		stroke: "#71717A",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgInsertImage);
export default ForwardRef;
